import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Checkbox from '@material-ui/core/Checkbox';

import GetAppIcon from '@material-ui/icons/GetApp';
import AddIcon from '@material-ui/icons/Add';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import NetworkWifiIcon from '@material-ui/icons/NetworkWifi';
import SignalWifiOffIcon from '@material-ui/icons/SignalWifiOff';

import Config from '../../constants/appConfig';
import MaterialIcon from '../../components/MaterialIcon';

import { notification } from 'antd';

import { useParams } from "react-router";

const styles = theme => ({});

class List extends React.Component {
    state = {
        jobs: [],
        serviceOrders: [],
        serviceOrderYearsMonths: [],
        serviceOrdersByMonth: {},
        loadingMonths: {},
        expandedYears: {},
        selectedMonths: {},
        selectedOsIds: {},
        isLoading: true,
        refreshing: false,
        deletingOsId: null,
        openDelete: false,
        deleteTargetOsId: null,
        openSendPlaneDialog: false,
        sendingPlaneNow: false,
        sendPlaneGuid: null,
        sendPlanePlaneId: null,
        planes: [],
        planesLoading: false,
        openSelectPlaneDialog: false,
        selectedPlaneId: null,
        selectPlaneGuid: null,
        downloading: null,
    };

    componentDidMount() {
        this.readServiceOrderYearsMonths();
        this.readPlanes();
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    };


    readServiceOrderYearsMonths = () => {
        const apiUrl = `${Config.server}/service_order/date`;
        const options = {
            method: 'GET',
            headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
        };
        fetch(apiUrl, options)
            .then((res) => { if (res.status !== 200) throw res; else return res.json(); })
            .then((result) => {
                this.setState({
                    serviceOrderYearsMonths: Array.isArray(result) ? result : [],
                    isLoading: false,
                    refreshing: false
                });
            })
            .catch((error) => {
                this.setState({ isLoading: false, refreshing: false });
                if (error.status === 405) {
                    notification.open({ message: this.props.res.PERMISSAO, description: this.props.res.PERMISSAO_MSG, icon: <MaterialIcon icon="error" className="text-danger" /> });
                } else if (error.status === 401 || error.status === 403) {
                    this.props.link('/login');
                } else {
                    notification.open({ message: this.props.res.ERRO, description: this.props.res.ERRO_MSG, icon: <MaterialIcon icon="error" className="text-danger" /> });
                }
            });
    };

    readServiceOrdersByMonth = (year, index, forceReload) => {
        const monthKey = `${year}-${index}`;
        const alreadyLoaded = !!this.state.serviceOrdersByMonth[monthKey];
        if (alreadyLoaded && forceReload !== true) return;

        const startDate = new Date(year, index, 1, 0, 0, 0, 0).getTime();
        const endDate = new Date(year, index + 1, 0, 23, 59, 59, 999).getTime();
        const apiUrl = `${Config.server}/service_order/${startDate}/${endDate}`;
        const options = {
            method: 'GET',
            headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
        };

        this.setState(prevState => ({
            loadingMonths: {
                ...(prevState.loadingMonths || {}),
                [monthKey]: true
            }
        }));

        fetch(apiUrl, options)
            .then((res) => { if (res.status !== 200) throw res; else return res.json(); })
            .then((result) => {
                const orders = Array.isArray(result) ? result : [];
                const selectedOsIds = { ...(this.state.selectedOsIds || {}) };
                const serviceOrdersByMonth = { ...(this.state.serviceOrdersByMonth || {}) };
                const serviceOrders = Array.isArray(this.state.serviceOrders) ? this.state.serviceOrders.slice() : [];
                const orderById = {};

                for (let i = 0; i < serviceOrders.length; i++) {
                    const os = serviceOrders[i] || {};
                    if (os.id != null) orderById[os.id] = os;
                }

                for (let i = 0; i < orders.length; i++) {
                    const os = orders[i] || {};
                    if (os.id != null) {
                        if (selectedOsIds[os.id] == null) selectedOsIds[os.id] = true;
                        orderById[os.id] = { ...(orderById[os.id] || {}), ...os };
                    }
                }

                serviceOrdersByMonth[monthKey] = orders;

                this.setState(prevState => ({
                    serviceOrders: Object.keys(orderById).map((id) => orderById[id]),
                    serviceOrdersByMonth: serviceOrdersByMonth,
                    selectedOsIds: selectedOsIds,
                    loadingMonths: {
                        ...(prevState.loadingMonths || {}),
                        [monthKey]: false
                    }
                }));
            })
            .catch((error) => {
                this.setState(prevState => ({
                    loadingMonths: {
                        ...(prevState.loadingMonths || {}),
                        [monthKey]: false
                    }
                }));
                if (error.status === 405) {
                    notification.open({ message: this.props.res.PERMISSAO, description: this.props.res.PERMISSAO_MSG, icon: <MaterialIcon icon="error" className="text-danger" /> });
                } else if (error.status === 401 || error.status === 403) {
                    this.props.link('/login');
                } else {
                    notification.open({ message: this.props.res.ERRO, description: this.props.res.ERRO_MSG, icon: <MaterialIcon icon="error" className="text-danger" /> });
                }
            });
    };

    readServiceOrder = () => {
        const apiUrl = `${Config.server}/service_order`;
        const options = {
            method: 'GET',
            headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
        };
        fetch(apiUrl, options)
            .then((res) => { if (res.status !== 200) throw res; else return res.json(); })
            .then((result) => {
                const orders = Array.isArray(result) ? result : [];
                const selectedOsIds = {};
                for (let i = 0; i < orders.length; i++) {
                    const os = orders[i] || {};
                    if (os.id != null) selectedOsIds[os.id] = true;
                }
                this.setState({
                    serviceOrders: orders,
                    selectedOsIds,
                    isLoading: false,
                    refreshing: false
                });
            })
            .catch((error) => {
                this.setState({ isLoading: false, refreshing: false });
                if (error.status === 405) {
                    notification.open({ message: this.props.res.PERMISSAO, description: this.props.res.PERMISSAO_MSG, icon: <MaterialIcon icon="error" className="text-danger" /> });
                } else if (error.status === 401 || error.status === 403) {
                    this.props.link('/login');
                } else {
                    notification.open({ message: this.props.res.ERRO, description: this.props.res.ERRO_MSG, icon: <MaterialIcon icon="error" className="text-danger" /> });
                }
            });
    };

    toggleYearExpand = (year) => {
        this.setState(prevState => ({
            expandedYears: {
                ...prevState.expandedYears,
                [year]: !prevState.expandedYears[year],
            },
        }));
    };

    handleMonthClick = (year, index) => {
        this.setState(prevState => {
            const yearSelected = prevState.selectedMonths[year] === index ? null : index;
            const updatedSelectedMonths = { ...prevState.selectedMonths, [year]: yearSelected };
            return { selectedMonths: updatedSelectedMonths };
        }, () => {
            if (this.state.selectedMonths[year] !== null) {
                this.readServiceOrdersByMonth(year, index);
            }
        });
    };

    toggleSelectOs = (osId) => {
        this.setState(prevState => {
            const selectedOsIds = { ...(prevState.selectedOsIds || {}) };
            selectedOsIds[osId] = !selectedOsIds[osId];
            return { selectedOsIds };
        });
    };

    getYearsFromOrders = () => {
        const orders = Array.isArray(this.state.serviceOrders) ? this.state.serviceOrders : [];
        const years = new Set();
        for (let i = 0; i < orders.length; i++) {
            const os = orders[i];
            const raw = os.created || os.created_at || os.createdAt || os.os_created_at || os.date || null;
            let created = null;
            if (raw) {
                const d = new Date(String(raw).replace(' ', 'T'));
                created = isNaN(d.getTime()) ? null : d;
            }
            if (!created) {
                const jobs = Array.isArray(os.jobs) ? os.jobs : [];
                const jobDates = jobs.map(j => new Date(String(((j && j.job_date) || '')).replace(' ', 'T'))).filter(d => d instanceof Date && !isNaN(d.getTime()));
                if (jobDates.length) created = new Date(Math.min(...jobDates.map(d => d.getTime())));
            }
            if (!created) created = new Date();
            const y = created.getFullYear();
            if (!isNaN(y)) years.add(y);
        }
        return Array.from(years);
    };

    buildJobRowsFromOrders = () => {
        const orders = Array.isArray(this.state.serviceOrders) ? this.state.serviceOrders : [];
        const rows = [];
        const parseMoney = (v) => {
            const n = Number(v);
            return isNaN(n) ? '' : n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        };
        const fmtDate = (iso) => {
            if (!iso) return '';
            const d = new Date(String(iso));
            if (isNaN(d)) return '';
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            return `${dd}/${mm}/${yyyy}`;
        };
        const monthIdx = (iso) => {
            if (!iso) return null;
            const d = new Date(String(iso));
            return isNaN(d) ? null : d.getMonth();
        };
        const safeEquip = (value) => {
            if (!value) return '';
            try {
                const obj = typeof value === 'string' ? JSON.parse(value) : value;
                const name = (obj && obj.name) ? obj.name : '';
                const type = (obj && obj.type) ? obj.type : '';
                return [type, name].filter(Boolean).join(' - ');
            } catch (e) { return String(value); }
        };
        for (let i = 0; i < orders.length; i++) {
            const os = orders[i];
            const jobs = Array.isArray(os?.jobs) ? os.jobs : [];
            for (let j = 0; j < jobs.length; j++) {
                const job = jobs[j];
                const fin = (Array.isArray(job.financials) && job.financials[0]) || job.financial || {};
                const products = Array.isArray(job.products) ? job.products : [];
                const productsLabel = products.map(p => p.product_name || p.name || p.id_product || p.id).join(', ');
                const dateStr = job.job_date || null;
                const dateObj = dateStr ? new Date(String(dateStr)) : null;
                rows.push({
                    id: job.id,
                    osId: os.id,
                    dateObj,
                    year: dateObj ? dateObj.getFullYear() : null,
                    monthIdx: monthIdx(dateStr),
                    serviceType: job.service_type || '',
                    status: os.status || '',
                    payment: fin.payment_method || '',
                    is_paid: fin.is_paid ? 1 : 0,
                    osNumber: os.order_number || '',
                    osTitle: os.title || '',
                    dateLabel: fmtDate(dateStr),
                    crop: job.crop || '',
                    productsLabel,
                    client: os.client || '',
                    pilot: job.pilot || '',
                    contact: os.contact || '',
                    responsible: os.responsible || '',
                    address: os.address || '',
                    property: os.property || '',
                    agronomo: '',
                    plane: job.plane || '',
                    area: job.area ?? null,
                    areaLabel: job.area ? `${job.area} ha` : '',
                    vazaoLabel: job.application_flow ? `${job.application_flow}` : '',
                    faixaLabel: job.strip_width ? `${job.strip_width}` : '',
                    equipLabel: safeEquip(job.equipment),
                    valorHaLabel: parseMoney(fin.value_per_hectare),
                    valorTotalLabel: parseMoney(fin.total_service_value),
                });
            }
        }
        return rows;
    };

    openDeleteDialog = (osId) => {
        this.setState({ openDelete: true, deleteTargetOsId: osId });
    };

    closeDeleteDialog = () => {
        this.setState({ openDelete: false, deleteTargetOsId: null });
    };

    confirmDeleteServiceOrder = () => {
        const osId = this.state.deleteTargetOsId;
        if (!osId) return this.closeDeleteDialog();
        this.closeDeleteDialog();
        const apiUrl = `${Config.server}/service_order/${osId}`;
        const prevList = this.state.serviceOrders;
        const optimistic = prevList.filter(o => Number(o.id) !== Number(osId));
        const serviceOrdersByMonth = { ...(this.state.serviceOrdersByMonth || {}) };
        Object.keys(serviceOrdersByMonth).forEach((key) => {
            const monthOrders = Array.isArray(serviceOrdersByMonth[key]) ? serviceOrdersByMonth[key] : [];
            serviceOrdersByMonth[key] = monthOrders.filter(o => Number(o.id) !== Number(osId));
        });
        this.setState({ deletingOsId: osId, serviceOrders: optimistic, serviceOrdersByMonth: serviceOrdersByMonth, refreshing: true });
        fetch(apiUrl, {
            method: 'DELETE',
            headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
        })
            .then((res) => { if (res.status !== 200) throw res; return res.json(); })
            .then(() => {
                this.setState({ deletingOsId: null });
                notification.open({
                    message: this.props.res.SUCESSO,
                    description: this.props.res.ITEM_EXCLUIDO,
                    icon: <MaterialIcon icon="check_circle" className="text-success" />
                });
                this.readServiceOrderYearsMonths();
            })
            .catch((error) => {
                this.setState({ deletingOsId: null });
                if (error.status === 405) {
                    notification.open({ message: this.props.res.PERMISSAO, description: this.props.res.PERMISSAO_MSG, icon: <MaterialIcon icon="error" className="text-danger" /> });
                } else if (error.status === 401 || error.status === 403) {
                    this.props.link('/login');
                } else if (error.status === 400) {
                    error.json().then((errCode) => {
                        notification.open({ message: this.props.res[errCode.code] || this.props.res.ERRO, icon: <MaterialIcon icon="error" className="text-danger" /> });
                    });
                } else {
                    notification.open({ message: this.props.res.ERRO, description: this.props.res.ERRO_MSG, icon: <MaterialIcon icon="error" className="text-danger" /> });
                }
                this.readServiceOrderYearsMonths();
            });
    };

    renderMonths = (year) => {
        const { res, link } = this.props;
        const months = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
        const selectedMonth = this.state.selectedMonths[year];
        const allJobs = this.buildJobRowsFromOrders() || [];
        const serviceOrders = Array.isArray(this.state.serviceOrders) ? this.state.serviceOrders : [];
        const serviceOrderYearsMonths = Array.isArray(this.state.serviceOrderYearsMonths) ? this.state.serviceOrderYearsMonths : [];
        const serviceOrdersByMonth = this.state.serviceOrdersByMonth || {};
        const loadingMonths = this.state.loadingMonths || {};
        const osById = {};
        for (let i = 0; i < serviceOrders.length; i++) {
            osById[serviceOrders[i].id] = serviceOrders[i];
        }
        const yearData = serviceOrderYearsMonths.find(item => Number(item.year) === Number(year)) || { months: [] };
        const availableMonths = Array.isArray(yearData.months) ? yearData.months : [];
        const monthKey = Number.isInteger(selectedMonth) && selectedMonth >= 0 ? `${year}-${selectedMonth}` : null;
        const monthLoading = monthKey ? !!loadingMonths[monthKey] : false;
        const parseDate = (v) => {
            if (!v) return null;
            if (v instanceof Date && !isNaN(v.getTime())) return v;
            const d = new Date(String(v).replace(' ', 'T'));
            return isNaN(d.getTime()) ? null : d;
        };
        const fmtDate = (d) => {
            if (!d) return '';
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            return `${dd}/${mm}/${d.getFullYear()}`;
        };
        const toNumber = (value) => {
            if (value === null || value === undefined) return 0;
            if (typeof value === 'number') return isFinite(value) ? value : 0;
            const text = String(value);
            const match = text.match(/-?\d{1,3}(?:\.\d{3})*(?:,\d+)?|-?\d+(?:\.\d+)?/);
            if (!match) return 0;
            const normalized = match[0].replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
            const n = parseFloat(normalized);
            return isNaN(n) ? 0 : n;
        };
        const orderNumberAsInt = (osNumber) => {
            const m = String(osNumber ?? '').match(/\d+/g);
            return m ? Number(m[m.length - 1]) : 0;
        };
        const resolveCreated = (os) => {
            let created = parseDate(os.created) || parseDate(os.created_at) || parseDate(os.createdAt) || parseDate(os.os_created_at) || parseDate(os.date);
            if (!created) {
                const jobs = Array.isArray(os.jobs) ? os.jobs : [];
                const jobDates = jobs.map(j => parseDate(j && j.job_date)).filter(Boolean);
                if (jobDates.length) created = new Date(Math.min(...jobDates.map(d => d.getTime())));
            }
            if (!created) created = new Date();
            return created;
        };
        const monthIsSelected = Number.isInteger(selectedMonth) && selectedMonth >= 0;
        const monthOrdersLoaded = monthKey && Array.isArray(serviceOrdersByMonth[monthKey]) ? serviceOrdersByMonth[monthKey] : null;
        const ordersForMonthSource = monthOrdersLoaded || serviceOrders.filter(os => {
            const created = resolveCreated(os);
            return created.getFullYear() === year && created.getMonth() === selectedMonth;
        });
        const ordersForMonth = ordersForMonthSource
            .map(os => {
                const created = resolveCreated(os);
                return {
                    osId: os.id,
                    osNumber: os.order_number || '',
                    title: os.title || '',
                    status: os.status || '',
                    responsible: os.responsible || '',
                    contact: os.contact || '',
                    property: os.property || '',
                    address: os.address || '',
                    created
                };
            })
            .sort((a, b) => orderNumberAsInt(b.osNumber) - orderNumberAsInt(a.osNumber));

        const selectedOsIds = this.state.selectedOsIds || {};
        const allChecked = ordersForMonth.length > 0
            ? ordersForMonth.every(o => !!selectedOsIds[o.osId])
            : false;
        const someChecked = ordersForMonth.some(o => !!selectedOsIds[o.osId]);

        const toggleSelectAllMonth = () => {
            const willCheck = !allChecked;
            this.setState(prevState => {
                const next = { ...(prevState.selectedOsIds || {}) };
                for (let i = 0; i < ordersForMonth.length; i++) {
                    next[ordersForMonth[i].osId] = willCheck;
                }
                return { selectedOsIds: next };
            });
        };
        const osIds = new Set(ordersForMonth.map(o => o.osId));
        let totalPrevisto = 0, totalRealizado = 0, totalHectares = 0;
        for (let i = 0; i < allJobs.length; i++) {
            const row = allJobs[i];
            if (!osIds.has(row.osId)) continue;
            const area = (row.area !== undefined && row.area !== null) ? toNumber(row.area) : toNumber(row.areaLabel);
            const valorHa = toNumber(row.valorHaLabel);
            const valorTotal = toNumber(row.valorTotalLabel);
            totalPrevisto += valorHa * area;
            totalRealizado += valorTotal;
            totalHectares += area;
        }

        let totalSprayed = 0;
        for (let i = 0; i < serviceOrders.length; i++) {
            const os = serviceOrders[i];
            if (!osIds.has(os.id)) continue;
            const jobs = Array.isArray(os.jobs) ? os.jobs : [];
            for (let j = 0; j < jobs.length; j++) {
                const job = jobs[j];
                const listExe = Array.isArray(job.list_exe) ? job.list_exe : [];
                for (let k = 0; k < listExe.length; k++) {
                    const exe = listExe[k];
                    const sprayed = toNumber(exe && exe.area_spray);
                    if (sprayed > 0) totalSprayed += sprayed;
                }
            }
        }

        return (
            <TableRow key={`months-${year}`}>
                <TableCell colSpan={9} style={{ textAlign: 'center', padding: '0.5rem 1rem' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', justifyContent: 'end', marginBottom: '1rem' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ paddingTop: '0.7rem' }}
                                className="popUpButton"
                                title={res.BAIXAR_RELATORIO_ANUAL}
                                onClick={() => this.downloadRelOrdemServicoPlanilha(year)}
                                disabled={this.state.downloading === year}
                            >
                                {this.state.downloading === year ? <CircularProgress size={24} /> : <GetAppIcon className="iconMapS" />}
                            </Button>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            {months.map((m, idx) => {
                                const monthData = availableMonths.find(item => Number(item.month) === Number(idx + 1));
                                const isAvailable = !!monthData;
                                return (
                                    <Button
                                        key={`${year}-${m}`}
                                        variant="contained"
                                        style={{ margin: '0.5rem', fontWeight: 600 }}
                                        onClick={() => isAvailable ? this.handleMonthClick(year, idx) : null}
                                        color={monthIsSelected && selectedMonth === idx ? 'primary' : 'default'}
                                        disabled={!isAvailable}
                                    >
                                        {m}
                                    </Button>
                                );
                            })}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '1rem', fontWeight: 'bold' }}>
                            <span>{res.VALOR_PREVISTO}: {totalPrevisto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                            <span>{res.VALOR_REALIZADO}: {totalRealizado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                            <span>{res.HECTARES_PENDENTES}: {totalHectares.toLocaleString('pt-BR')}</span>
                            <span>{res.HECTARES_PULVERIZADOS}: {totalSprayed.toLocaleString('pt-BR')}</span>
                        </div>
                        {monthIsSelected ? (
                            monthLoading ? (
                                <div style={{ marginTop: '2rem', display: 'flex', justifyContent: 'center' }}>
                                    <CircularProgress size={28} />
                                </div>
                            ) : ordersForMonth.length > 0 ? (
                                <Table style={{ marginTop: '2rem' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    indeterminate={!allChecked && someChecked}
                                                    checked={allChecked}
                                                    onChange={toggleSelectAllMonth}
                                                    color="primary"
                                                />
                                            </TableCell>
                                            <TableCell>{res.TITULO}</TableCell>
                                            <TableCell>{res.STATUS}</TableCell>
                                            <TableCell>{res.NUMERO_OS}</TableCell>
                                            <TableCell>{res.RESPONSAVEL}</TableCell>
                                            <TableCell>{res.CONTATO}</TableCell>
                                            <TableCell>{res.PROPRIEDADE}</TableCell>
                                            <TableCell>{res.ENDERECO}</TableCell>
                                            <TableCell>{res.DATA}</TableCell>
                                            <TableCell>{res.ACOES}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {ordersForMonth.map((o) => (
                                            <TableRow key={o.osId}>
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={!!selectedOsIds[o.osId]}
                                                        onChange={() => this.toggleSelectOs(o.osId)}
                                                        color="primary"
                                                    />
                                                </TableCell>
                                                <TableCell>{o.title}</TableCell>
                                                <TableCell>{o.status}</TableCell>
                                                <TableCell>{o.osNumber}</TableCell>
                                                <TableCell>{o.responsible}</TableCell>
                                                <TableCell>{o.contact}</TableCell>
                                                <TableCell>{o.property}</TableCell>
                                                <TableCell>{o.address}</TableCell>
                                                <TableCell>{fmtDate(o.created)}</TableCell>
                                                <TableCell>
                                                    {this.renderOsPlanningAction(osById[o.osId] || {})}

                                                    <IconButton onClick={() => link(`/app/ordem-servico/edit/${o.osId}`)} title={res.EDITAR}>
                                                        <EditIcon />
                                                    </IconButton>

                                                    <IconButton
                                                        onClick={() => this.openDeleteDialog(o.osId)}
                                                        title={res.EXCLUIR}
                                                        disabled={this.state.deletingOsId === o.osId || this.state.refreshing}
                                                    >
                                                        {this.state.deletingOsId === o.osId ? <CircularProgress size={20} /> : <DeleteIcon />}
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : (
                                <div style={{ marginTop: '2rem' }}>{res.SEM_ORDEM_SERVICO}</div>
                            )
                        ) : (
                            <div style={{ marginTop: '2rem' }}>{res.SELECIONAR_MES_OS}</div>
                        )}
                    </div>
                </TableCell>
            </TableRow>
        );
    };

    renderLoadingBlock = () => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3rem 0' }}>
                <CircularProgress size={32} />
            </div>
        );
    };

    getOsPlanningState = (os) => {
        const jobs = Array.isArray(os && os.jobs) ? os.jobs : [];

        let hasPlanning = false;
        let hasSent = false;
        let hasPlannedNotSent = false;

        for (let i = 0; i < jobs.length; i++) {
            const job = jobs[i] || {};

            const jlPl = Number(job.jl_pl) || 0;
            const jlSk = Number(job.jl_sk) || 0;

            const listPlan = Array.isArray(job.list_plan) ? job.list_plan : [];
            const listExe = Array.isArray(job.list_exe) ? job.list_exe : [];
            const listTransf = Array.isArray(job.list_transf_plan) ? job.list_transf_plan : [];

            const transferPl = Number(job.transfer_pl) || 0;

            const hasPlanHere = (jlPl > 0) || (listPlan.length > 0);
            if (!hasPlanHere) continue;

            hasPlanning = true;

            const alreadyReceivedOrExecuted = (jlSk > 0) || (listExe.length > 0);

            const hasAnyTransferSuccess = (transferPl > 0) || (listTransf.length > 0);

            const planningWasSent = alreadyReceivedOrExecuted || hasAnyTransferSuccess;

            if (planningWasSent) {
                hasSent = true;
            } else {
                hasPlannedNotSent = true;
            }
        }

        if (!hasPlanning) return 'none';
        if (hasSent) return 'sent';
        if (hasPlannedNotSent) return 'planned';
        return 'none';
    };

    resolveOsPlanningCandidate = (os) => {
        const jobs = Array.isArray(os && os.jobs) ? os.jobs : [];

        let candidate = null;

        for (let i = 0; i < jobs.length; i++) {
            const job = jobs[i] || {};

            const jlPl = Number(job.jl_pl) || 0;
            const listPlan = Array.isArray(job.list_plan) ? job.list_plan : [];
            const hasPlanHere = (jlPl > 0) || (listPlan.length > 0);

            if (!hasPlanHere) continue;

            const jlSk = Number(job.jl_sk) || 0;
            const listExe = Array.isArray(job.list_exe) ? job.list_exe : [];
            const listTransf = Array.isArray(job.list_transf_plan) ? job.list_transf_plan : [];
            const transferPl = Number(job.transfer_pl) || 0;

            const alreadyReceivedOrExecuted = (jlSk > 0) || (listExe.length > 0);
            const hasAnyTransferSuccess = (transferPl > 0) || (listTransf.length > 0);

            const planningWasSent = alreadyReceivedOrExecuted || hasAnyTransferSuccess;

            if (!planningWasSent) {
                candidate = job;
                break;
            }

            if (!candidate) candidate = job;
        }

        return candidate;
    };

    openSendPlaneDialogForOs = (os) => {
        const { res } = this.props;

        const state = this.getOsPlanningState(os);
        if (state !== 'planned') return;

        const candidate = this.resolveOsPlanningCandidate(os);
        if (!candidate) return;

        const listPlan = Array.isArray(candidate && candidate.list_plan) ? candidate.list_plan : [];

        const planningGuid =
            (listPlan[0] && listPlan[0].guid) ||
            (candidate && (candidate.job_guid || candidate.guid)) ||
            null;

        let planeId =
            (candidate && candidate.id_plane != null ? candidate.id_plane : null) ||
            (candidate && candidate.idPlane != null ? candidate.idPlane : null) ||
            (listPlan[0] && listPlan[0].id_plane != null ? listPlan[0].id_plane : null) ||
            null;

        if (!planningGuid) {
            notification.open({
                message: res.ERRO,
                description: res.GUIA_PLANEJAMENTO_INVALIDO,
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return;
        }

        if (planeId === null || planeId === undefined || Number(planeId) <= 0) {
            const planes = Array.isArray(this.state.planes) ? this.state.planes : [];
            const planeName = String((candidate && candidate.plane) ? candidate.plane : '').trim().toLowerCase();

            if (planeName) {
                let found = null;

                for (let i = 0; i < planes.length; i++) {
                    const planeItem = planes[i] || {};
                    const planeItemId = (planeItem.id != null ? planeItem.id : planeItem.id_plane);
                    const planeItemLabel = String(
                        planeItem.name || planeItem.title || planeItem.prefix || planeItem.registration || planeItem.code || ''
                    ).trim().toLowerCase();

                    if (planeItemId && planeItemLabel && planeItemLabel === planeName) { found = Number(planeItemId); break; }
                }

                if (!found) {
                    for (let i = 0; i < planes.length; i++) {
                        const planeItem = planes[i] || {};
                        const planeItemId = (planeItem.id != null ? planeItem.id : planeItem.id_plane);
                        const planeItemLabel = String(
                            planeItem.name || planeItem.title || planeItem.prefix || planeItem.registration || planeItem.code || ''
                        ).trim().toLowerCase();

                        if (planeItemId && planeItemLabel && (planeItemLabel.indexOf(planeName) >= 0 || planeName.indexOf(planeItemLabel) >= 0)) {
                            found = Number(planeItemId);
                            break;
                        }
                    }
                }

                if (found && found > 0) planeId = found;
            }
        }

        if (planeId === null || planeId === undefined || Number(planeId) <= 0) {
            notification.open({
                message: res.ERRO,
                description: res.INFORMAR_AERONAVE_OS,
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return;
        }

        this.setState({
            openSendPlaneDialog: true,
            sendPlaneGuid: planningGuid,
            sendPlanePlaneId: Number(planeId)
        });
    };

    closeSendPlaneDialog = () => {
        if (this.state.sendingPlaneNow === true) return;

        this.setState({
            openSendPlaneDialog: false,
            sendingPlaneNow: false,
            sendPlaneGuid: null,
            sendPlanePlaneId: null
        });
    };

    confirmSendPlane = () => {
        const { res } = this.props;

        const guid = this.state.sendPlaneGuid;
        const planeId = this.state.sendPlanePlaneId;

        if (!guid) {
            notification.open({
                message: res.ERRO,
                description: res.GUIA_PLANEJAMENTO_INVALIDO || res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return;
        }

        if (!planeId && planeId !== 0) {
            notification.open({
                message: res.ERRO,
                description: res.INFORMAR_AERONAVE_OS,
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return;
        }

        this.sendPlanningToPlane(guid, planeId, { closeDialogOnStart: true });
    };

    sendPlanningToPlane = (planningGuid, planeId, options) => {
        const closeDialogOnStart = !!(options && options.closeDialogOnStart);

        if (!planningGuid) return;
        if (!planeId && planeId !== 0) return;

        if (closeDialogOnStart) {
            this.setState({ openSendPlaneDialog: false, sendingPlaneNow: true });
        } else {
            this.setState({ sendingPlaneNow: true });
        }

        const apiUrl = Config.server + '/transfer';
        const formData = new URLSearchParams();

        formData.append('list_plane', JSON.stringify([Number(planeId)]));
        formData.append('guid', String(planningGuid));
        formData.append('type', 'job');

        const optionsFetch = {
            method: 'POST',
            body: formData,
            headers: {
                Authorization: localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, optionsFetch)
            .then((resData) => {
                if (resData.status !== 200) throw resData;
                return resData.json();
            })
            .then(
                (result) => {
                    this.setState({
                        sendingPlaneNow: false,
                        openSendPlaneDialog: false,
                        sendPlaneGuid: null,
                        sendPlanePlaneId: null
                    });

                    if (result && result.msg) {
                        notification.open({
                            message: this.props.res.ENVIANDO_PLANEJAMENTO || this.props.res.ENVIANDO_TRABALHO,
                            icon: <MaterialIcon icon="check_circle" className="text-success" />
                        });

                        setTimeout(() => {
                            this.readServiceOrderYearsMonths();
                            const selectedMonths = this.state.selectedMonths || {};
                            Object.keys(selectedMonths).forEach((year) => {
                                const month = selectedMonths[year];
                                if (month !== null && month !== undefined) {
                                    this.readServiceOrdersByMonth(Number(year), Number(month), true);
                                }
                            });
                        }, 200);
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                },
                (error) => {
                    this.setState({ sendingPlaneNow: false });

                    if (error && error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error && (error.status === 401 || error.status === 403)) {
                        this.props.link('/login');
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    renderOsPlanningAction = (os) => {
        const { res } = this.props;

        const state = this.getOsPlanningState(os);

        const disabled = (state === 'none') || (state === 'sent');

        const iconColor =
            state === 'sent' ? '#4caf50' :
                state === 'planned' ? '#ffc107' :
                    '#9e9e9e';

        const title =
            state === 'sent' ? res.PLANEJAMENTO_ENVIADO_AERONAVE :
                state === 'planned' ? res.ENVIAR_PLANEJAMENTO_AERONAVE :
                    res.SEM_PLANEJAMENTO;

        const IconComp = (state === 'sent') ? NetworkWifiIcon : SignalWifiOffIcon;

        return (
            <IconButton
                disabled={disabled}
                title={title}
                onClick={() => this.openSendPlaneDialogForOs(os)}
            >
                <IconComp style={{ color: iconColor }} />
            </IconButton>
        );
    };

    readPlanes = () => {
        const apiUrl = `${Config.server}/plane`;

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        this.setState({ planesLoading: true });

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                return res.json();
            })
            .then((result) => {
                this.setState({
                    planes: Array.isArray(result) ? result : [],
                    planesLoading: false
                });
            })
            .catch((error) => {
                this.setState({ planesLoading: false });

                if (error && error.status === 405) {
                    notification.open({
                        message: this.props.res.PERMISSAO,
                        description: this.props.res.PERMISSAO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                } else if (error && (error.status === 401 || error.status === 403)) {
                    this.props.link('/login');
                } else {
                    notification.open({
                        message: this.props.res.ERRO,
                        description: this.props.res.ERRO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                }
            });
    };

    closeSelectPlaneDialog = () => {
        if (this.state.sendingPlaneNow === true) return;

        this.setState({
            openSelectPlaneDialog: false,
            selectedPlaneId: null,
            selectPlaneGuid: null
        });
    };

    confirmSelectPlaneAndSend = () => {
        const { res } = this.props;

        const guid = this.state.selectPlaneGuid;
        const planeId = this.state.selectedPlaneId;

        if (!guid) {
            notification.open({
                message: res.ERRO,
                description: res.GUIA_PLANEJAMENTO_INVALIDO || res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return;
        }

        if (!planeId || Number(planeId) <= 0) {
            notification.open({
                message: res.ERRO,
                description: res.INFORMAR_AERONAVE_OS,
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return;
        }

        this.setState({ openSelectPlaneDialog: false }, () => {
            this.sendPlanningToPlane(guid, Number(planeId), { closeDialogOnStart: false });
        });
    };

    downloadRelOrdemServicoPlanilha = (year) => {
        this.setState({ downloading: year });

        const apiUrl = Config.server + '/relOrdemServicoPlanilha';
        const formData = new URLSearchParams();

        const serviceOrders = Array.isArray(this.state.serviceOrders) ? this.state.serviceOrders : [];
        const selectedOsIds = this.state.selectedOsIds || {};

        const parseDate = (v) => {
            if (!v) return null;
            if (v instanceof Date && !isNaN(v.getTime())) return v;
            const d = new Date(String(v).replace(' ', 'T'));
            return isNaN(d.getTime()) ? null : d;
        };

        const resolveCreated = (os) => {
            let created = parseDate(os.created) || parseDate(os.created_at) || parseDate(os.createdAt) || parseDate(os.os_created_at) || parseDate(os.date);
            if (!created) created = new Date();
            return created;
        };

        const selectedOrders = serviceOrders
            .filter(os => !!selectedOsIds[os.id])
            .map(os => {
                const created = resolveCreated(os);
                return { ...os, created };
            })
            .filter(os => os.created && os.created.getFullYear() === year);

        formData.append('year', year);
        formData.append('serviceOrders', JSON.stringify(selectedOrders));
        formData.append('culture', this.props.res.LINGUA);

        const options = {
            method: 'POST',
            body: formData,
            headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
        };

        fetch(apiUrl, options)
            .then(res => {
                if (res.status !== 200) throw res;
                return res.blob();
            })
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Relatorio-ORDEM-SERVICO-${year}.xlsx`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
                this.setState({ downloading: null });
            })
            .catch(() => {
                notification.open({
                    message: this.props.res.ERRO,
                    description: this.props.res.ERRO_MSG,
                    icon: <MaterialIcon icon="error" className="text-danger" />
                });
                this.setState({ downloading: null });
            });
    };

    render() {
        const { res, link } = this.props;
        const showLoading = this.state.isLoading || this.state.refreshing;

        return (
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h1>{res.ORDEM_SERVICO}</h1>
                    <Tooltip title={res.ADD}>
                        <IconButton
                            aria-label="Add"
                            onClick={event => { if (!(this.state.isLoading || this.state.refreshing)) this.props.link('/app/ordem-servico/edit'); }}
                            disabled={this.state.isLoading || this.state.refreshing}
                        >
                            <AddIcon />
                        </IconButton>
                    </Tooltip>
                </div>

                <div>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>

                        {(this.state.isLoading || this.state.refreshing) ? (
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={2} align="center" style={{ padding: 0 }}>
                                        <div style={{ position: 'relative', width: '100%' }}>
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                                    zIndex: 2
                                                }}
                                            />
                                            <div
                                                style={{
                                                    padding: '2.5rem 0',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    position: 'relative',
                                                    zIndex: 3
                                                }}
                                            >
                                                <CircularProgress size={48} style={{ color: '#9e9e9e' }} />
                                            </div>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        ) : (
                            <TableBody>
                                {(Array.isArray(this.state.serviceOrderYearsMonths) ? this.state.serviceOrderYearsMonths : []).map((item) => (
                                    <React.Fragment key={item.year}>
                                        <TableRow onClick={() => this.toggleYearExpand(item.year)}>
                                            <TableCell style={{ width: '96%', borderBottom: this.state.expandedYears[item.year] ? 'none' : '' }}>
                                                <h2 style={{ fontSize: '1.75rem' }}>{item.year}</h2>
                                            </TableCell>
                                            <TableCell style={{ width: '4%', textAlign: 'center', borderBottom: this.state.expandedYears[item.year] ? 'none' : '' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    {this.state.expandedYears[item.year] ? <KeyboardArrowUpIcon className="iconMapS" /> : <KeyboardArrowDownIcon className="iconMapS" />}
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                        {this.state.expandedYears[item.year] ? this.renderMonths(item.year) : null}
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        )}
                    </Table>
                </div>

                <Dialog open={this.state.openDelete} onClose={this.closeDeleteDialog}>
                    <DialogTitle style={{ padding: '0' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#2D3238', padding: '0.5rem 0' }}>
                            <div style={{ width: '16%', textAlign: 'left' }}></div>
                            <div style={{ textAlign: 'center' }}>
                                <p style={{ color: 'white', margin: '0' }}>{res.EXCLUIR_OS}</p>
                            </div>
                            <div style={{ width: '16%', textAlign: 'right' }}>
                                <Button size="small" className="popUpButton" onClick={this.closeDeleteDialog}>
                                    <CloseIcon style={{ color: 'white' }} />
                                </Button>
                            </div>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText style={{ color: 'black' }}>{res.CONFIRMAR_EXCLUSAO_OS}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeDeleteDialog} color="primary">
                            {res.NAO}
                        </Button>
                        <Button onClick={this.confirmDeleteServiceOrder} color="primary" autoFocus>
                            {res.SIM}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.openSendPlaneDialog === true}
                    onClose={this.closeSendPlaneDialog}
                    maxWidth="sm"
                    fullWidth
                    disableBackdropClick={this.state.sendingPlaneNow === true}
                    disableEscapeKeyDown={this.state.sendingPlaneNow === true}
                    BackdropProps={{ style: { backgroundColor: 'rgba(0,0,0,0.5)' } }}
                    PaperProps={{ style: { background: 'white' } }}
                >
                    <DialogTitle style={{ padding: 0 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#2D3238', padding: '0.5rem 0' }}>
                            <div style={{ width: '16%', textAlign: 'left' }} />
                            <div style={{ textAlign: 'center' }}>
                                <p style={{ color: 'white', margin: 0 }}>
                                    {this.props.res.ENVIAR_PLANEJAMENTO}
                                </p>
                            </div>
                            <div style={{ width: '16%', textAlign: 'right' }}>
                                <Button size="small" className="popUpButton" onClick={this.closeSendPlaneDialog}>
                                    <CloseIcon style={{ color: 'white' }} />
                                </Button>
                            </div>
                        </div>
                    </DialogTitle>

                    <DialogContent style={{ background: 'white' }}>
                        <DialogContentText style={{ color: 'black' }}>
                            {this.props.res.CONFIRMAR_ENVIO_PLANEJAMENTO}
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions style={{ background: 'white' }}>
                        <Button onClick={this.closeSendPlaneDialog} color="primary" disabled={this.state.sendingPlaneNow === true}>
                            {this.props.res.NAO}
                        </Button>

                        <Button
                            onClick={this.confirmSendPlane}
                            color="primary"
                            variant="contained"
                            disabled={this.state.sendingPlaneNow === true}
                        >
                            {this.props.res.SIM}
                        </Button>
                    </DialogActions>
                </Dialog>

            </div>
        );
    }
}

List.propTypes = {
    classes: PropTypes.object.isRequired,
};

const TextFields1 = withStyles(styles)(List);

const Box = (props) => {
    const { link, res, profile } = props;
    let { id } = useParams();
    return (
        <div className="rowForm">
            <div className="divContent">
                <TextFields1 profile={profile} link={link} id={id} res={res} />
            </div>
        </div>
    );
};

export default Box;